export default "__VITE_ASSET__2ojjpETD__"